import React, { Fragment, useState } from 'react'
import { Grid, TextField, MenuItem, Button } from '@mui/material'
import { SelectedZone } from '../../../interfaces/Picking/Picking'

export interface Zone {
  zoneId: number
  zoneName: string
}

interface ZoneSelectProps {
  zones: Zone[]
  isEditingZone: boolean
  label?: string
  prefixNameStorage: string
  userId: number
  selectedZoneId: number
  setSelectedZoneId: (id: number) => void
  setIsEditingZone: (isEditing: boolean) => void
  isMobile: boolean
  canChangeZone?: boolean
}

export const ZoneSelect: React.FC<ZoneSelectProps> = ({
  zones,
  isEditingZone,
  prefixNameStorage,
  userId,
  selectedZoneId,
  setSelectedZoneId,
  setIsEditingZone,
  isMobile,
  label = 'Seleccione Zonas',
  canChangeZone = true
}) => {
  const [tempSelectedZoneId, setTempSelectedZoneId] =
    useState<number>(selectedZoneId)

  const zoneValue = () => {
    if (isEditingZone) return tempSelectedZoneId
    return selectedZoneId
  }

  return (
    <Fragment>
      <Grid
        item
        xs={11}
        sm={6}
        md={4}
        style={{ width: isMobile ? '100%' : '50%' }}
      >
        <TextField
          value={zoneValue()}
          onChange={(e) => setTempSelectedZoneId(Number(e.target.value))}
          label={label}
          fullWidth
          select
          variant='outlined'
          inputProps={{
            style: { textAlign: 'center' },
            readOnly: !isEditingZone
          }}
          disabled={!isEditingZone}
          InputProps={{
            style: isEditingZone
              ? {
                  border: '1px solid #4287e2ff',
                  boxShadow: '0 0 5px 2px #4287e2ff',
                  borderRadius: '4px',
                  transition: 'box-shadow 0.3s ease',
                  backgroundColor: '#fefeffff'
                }
              : {}
          }}
        >
          {zones.map((item) => (
            <MenuItem key={item.zoneId} value={item.zoneId}>
              {item.zoneName}
            </MenuItem>
          ))}
        </TextField>
      </Grid>
      {canChangeZone && (
        <Grid
          container
          justifyContent='center'
          style={{ width: '100%' }}
        >
          <Grid
            item
            xs={11}
            sm={6}
            md={4}
            style={{ display: 'flex', justifyContent: 'center', marginTop: 15 }}
          >
            <Button
              style={{
                minHeight: 40,
                fontSize: isMobile ? '1.1rem' : '1rem',
                width: isMobile ? '100%' : '250px'
              }}
              variant='contained'
              color={isEditingZone ? 'secondary' : 'inherit'}
              fullWidth={isMobile}
              onClick={() => {
                if (isEditingZone && tempSelectedZoneId) {
                  setSelectedZoneId(tempSelectedZoneId)

                  // Guardar zona en localStorage por usuario
                  const key = `${prefixNameStorage}${userId}`
                  const selectedZone: SelectedZone = {
                    selectedZoneId: tempSelectedZoneId,
                    userId: userId
                  }

                  localStorage.setItem(key, JSON.stringify(selectedZone))
                } else {
                  setTempSelectedZoneId(selectedZoneId)
                }
                setIsEditingZone(!isEditingZone)
              }}
            >
              {isEditingZone ? 'Guardar Zona' : 'Cambiar Zona'}
            </Button>
          </Grid>
        </Grid>
      )}
    </Fragment>
  )
}
